import { render, staticRenderFns } from "./ExtraPageMenu.vue?vue&type=template&id=967f44b2&scoped=true&"
import script from "./ExtraPageMenu.vue?vue&type=script&lang=ts&"
export * from "./ExtraPageMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraPageMenu.vue?vue&type=style&index=0&id=967f44b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f44b2",
  null
  
)

export default component.exports